import {
  isTrendsSummaryLanguage,
  TRENDS_SUMMARY_FALLBACK_LANGUAGE,
  type TrendsSummaryLanguage,
} from 'fym-shared/src/aiInsights/summaryLanguages';

/**
 * The language to ask the trends summary in: the app language when a summary exists in it, else
 * English. music24-api refuses any other language.
 */
export function summaryLanguage(locale: string): TrendsSummaryLanguage {
  const language = locale.split('-')[0] ?? TRENDS_SUMMARY_FALLBACK_LANGUAGE;
  return isTrendsSummaryLanguage(language) ? language : TRENDS_SUMMARY_FALLBACK_LANGUAGE;
}
